import routeTemplates from 'common/route-templates';

export const checkGroupPermission = groupPermission => {
  let isGranted = false;

  function recurseCheckPermission(groupPermission) {
    if (groupPermission && groupPermission.permissions && groupPermission.permissions.length > 0) {
      isGranted = true;
      return true;
    }
    if (groupPermission && groupPermission.resources) {
      for (let i = 0; i < Object.keys(groupPermission.resources).length; i++) {
        if (
          recurseCheckPermission(
            groupPermission.resources[Object.keys(groupPermission.resources)[i]]
          )
        )
          break;
      }
    }
  }
  recurseCheckPermission(groupPermission);
  return isGranted;
};

export const isWriteAble = permission => Array.isArray(permission) && permission.includes('write');

export const checkActiveAuthorizedPage = userPermissions => {
  let pageUrl = routeTemplates.project.projectSettings.profile;

  if (userPermissions && userPermissions.inbox && checkGroupPermission(userPermissions.inbox)) {
    pageUrl = routeTemplates.project.inbox.root;
  } else if (
    userPermissions &&
    userPermissions.conversations &&
    checkGroupPermission(userPermissions.conversations)
  ) {
    pageUrl = routeTemplates.project.audiences.root;
  } else if (
    userPermissions &&
    userPermissions.analytics &&
    checkGroupPermission(userPermissions.analytics)
  ) {
    pageUrl = routeTemplates.project.analytics;
  } else if (checkActiveAuthorizedSettingsPage(userPermissions)) {
    pageUrl = checkActiveAuthorizedSettingsPage(userPermissions);
  }
  return pageUrl;
};

export const pageRedirectPermission = (userPermissions, props) => {
  let shouldShow401Page =
    props &&
    props.computedMatch &&
    props.computedMatch.params &&
    Object.keys(props.computedMatch.params).length === 0 &&
    props.computedMatch.params.constructor === Object;

  if (!shouldShow401Page) {
    return checkActiveAuthorizedPage(userPermissions);
  }

  return;
};

export const checkActiveAuthorizedSettingsPage = userPermissions => {
  let pageUrl = routeTemplates.project.projectSettings.profile;
  const integrationPermissionGranted =
    userPermissions &&
    userPermissions.settings &&
    userPermissions.settings.resources &&
    checkGroupPermission(userPermissions.settings.resources.integrations);
  const teamPermissionGranted =
    userPermissions &&
    userPermissions.settings &&
    userPermissions.settings.resources &&
    checkGroupPermission(userPermissions.settings.resources.team);
  const widgetSettingsPermissionGranted =
    userPermissions &&
    userPermissions.settings &&
    userPermissions.settings.resources &&
    checkGroupPermission(userPermissions.settings.resources.widgetSettings);

  if (integrationPermissionGranted) {
    pageUrl = routeTemplates.project.projectSettings.integrations;
  } else if (teamPermissionGranted) {
    pageUrl = routeTemplates.project.projectSettings.team;
  } else if (widgetSettingsPermissionGranted) {
    pageUrl = routeTemplates.project.projectSettings.widget;
  }
  return pageUrl;
};
